export const BUY_URL = 'https://ebookpoint.shop/cart/50005688189180:1'
export const SUPPORT_EMAIL = 'EbookDreamShop@gmail.com'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/7y19iqT9292BRnCxC7arff/ChatGPT_Image_Jul_15,_2026,_03_28_20_AM.png'

export const GYM_BG =
  'https://cdn.magicpatterns.com/patterns/generated-images/5a3312ed-82ee-469e-8557-1ef46188cacd.jpg'

export const PRICE = '27 EUROS'
export const OLD_PRICE = '78 EUROS'

export const TOTAL_CUPOS = 948

export interface ModuleItem {
  emoji: string
  title: string
  points: string[]
}

export const MODULES: ModuleItem[] = [
  {
    emoji: '💼',
    title: 'Módulo 1: El Negocio de Entrenar HYROX (40-45 pág)',
    points: [
      '1.1 Por qué HYROX es una oportunidad de negocio distinta al personal training tradicional',
      '1.2 Perfil de tu cliente ideal: atleta recreativo vs. competidor serio',
      '1.3 Modelos de servicio: clases grupales, programación 1 a 1, híbrido',
      '1.4 Cómo diferenciarte de otros boxes/gimnasios que "también hacen HYROX"',
      '1.5 Estructura de precios: mensual, por objetivo de competencia, paquetes de temporada',
      '1.6 Captación de alumnos nuevos: canales, mensajes, primer contacto',
      '1.7 Retención en temporada baja: qué hacer cuando termina la temporada de competencias',
      '1.8 Autoevaluación: ¿tu oferta actual está clara para el cliente o es ambigua?',
    ],
  },
  {
    emoji: '🩺',
    title: 'Módulo 2: Evaluación y Onboarding de Clientes (45-50 pág)',
    points: [
      '2.1 Protocolo de primera clase / primera sesión de evaluación',
      '2.2 Cómo detectar limitaciones de movilidad antes de programar',
      '2.3 Historial de lesiones: preguntas clave y banderas rojas',
      '2.4 Test de nivel aplicado a terceros (versión profesional)',
      '2.5 Clasificación de clientes: principiante, intermedio, avanzado, con patología',
      '2.6 Expectativas realistas: cómo comunicar tiempos de progreso sin sobre-prometer',
      '2.7 Documentación mínima de cada cliente para tener trazabilidad de su evolución',
    ],
  },
  {
    emoji: '👥',
    title: 'Módulo 3: Programación para Grupos con Niveles Mixtos (50-55 pág)',
    points: [
      '3.1 El problema central del entrenador de HYROX: una clase, múltiples niveles',
      '3.2 Auto-regulación de carga: cómo dar la misma sesión con variaciones seguras',
      '3.3 Variaciones por estación (sled, wall balls, lunges) según nivel del alumno',
      '3.4 Cómo organizar heats y series dentro de una clase sin perder tiempo',
      '3.5 Progresión de complejidad técnica sin frenar el ritmo grupal',
      '3.6 Gestión de clientes con lesiones activas dentro de una clase grupal',
      '3.7 Errores comunes al programar para grupos: sobrecargar al débil, aburrir al fuerte',
    ],
  },
  {
    emoji: '🎯',
    title: 'Módulo 4: Corrección Técnica y Detección de Riesgo (45-50 pág)',
    points: [
      '4.1 Cues verbales efectivos por estación (qué decir, cuándo y cómo)',
      '4.2 Señales visuales de fatiga peligrosa: cuándo intervenir y cuándo dejar seguir',
      '4.3 Compensaciones técnicas más comunes por estación y cómo corregirlas rápido',
      '4.4 Corrección sin frenar el flujo de la clase: técnica de intervención breve',
      '4.5 Cuándo derivar a un profesional médico (y cómo comunicarlo al alumno)',
      '4.6 Responsabilidad del entrenador: qué cubre tu rol y qué no',
      '4.7 Checklist de seguridad para clases grupales de alta intensidad',
    ],
  },
  {
    emoji: '🏋️',
    title: 'Módulo 5: Diseño de Sesión y Estructura de Clase (45-50 pág)',
    points: [
      '5.1 Estructura tipo de clase de 60 minutos: warm-up, bloque técnico, bloque metabólico, cierre',
      '5.2 Cómo calcar la estructura semana a semana sin perder variedad',
      '5.3 Plantillas de sesión por objetivo: técnica, fuerza, resistencia, simulacro',
      '5.4 Gestión de tiempo y espacio en box con equipamiento limitado',
      '5.5 Clases de 45 min vs. 60 min vs. 90 min: cuándo usar cada formato',
      '5.6 Cómo programar semanas de descarga a nivel grupal sin bajar la asistencia',
      '5.7 Diseño de simulacros grupales previos a competencia',
    ],
  },
  {
    emoji: '📊',
    title: 'Módulo 6: Seguimiento y Gestión de Múltiples Clientes (40-45 pág)',
    points: [
      '6.1 Cómo trackear la evolución de cada alumno sin perder tiempo administrativo',
      '6.2 Gestión de calendario cuando tenés clientes preparando distintas competencias',
      '6.3 Periodización individual dentro de un marco de clases grupales',
      '6.4 Comunicación de resultados y feedback: cómo mantener motivado a cada perfil',
      '6.5 Identificar cuándo un cliente necesita programación 1 a 1 en vez de grupal',
      '6.6 Herramientas simples de seguimiento (sin necesidad de software complejo)',
    ],
  },
  {
    emoji: '📈',
    title: 'Módulo 7: Venta, Retención y Crecimiento (45-50 pág)',
    points: [
      '7.1 Cómo presentar tu programa HYROX para cerrar planes mensuales',
      '7.2 Scripts de venta para primera consulta / clase de prueba',
      '7.3 Objeciones comunes de clientes nuevos y cómo resolverlas',
      '7.4 Estrategias de retención: qué hace que un alumno se quede 6+ meses',
      '7.5 Cómo aprovechar el calendario de competencias para generar urgencia de venta',
      '7.6 Testimonios y contenido de resultados: cómo documentar el progreso de tus alumnos',
      '7.7 Escalar tu oferta: de clases grupales a programas premium 1 a 1',
    ],
  },
]

export interface BonusItem {
  emoji: string
  title: string
  description: string
  image: string
}

export const BONUSES: BonusItem[] = [
  {
    emoji: '📗',
    title: 'Bono 1 — Planificador Multi-Cliente (Excel)',
    description:
      'Versión ampliada del planificador de 12 semanas, pero con seguimiento simultáneo de varios alumnos en distintas fases de periodización y distintas fechas de competencia.',
    image:
      'https://cdn.magicpatterns.com/uploads/wcbVL8jXQsUCkyGHDDPgCp/Bono1_Planificador_MultiCliente.png',
  },
  {
    emoji: '📋',
    title: 'Bono 2 — Checklist de Evaluación de Nuevo Alumno (PDF)',
    description:
      'Protocolo imprimible de primera clase: preguntas de historial, test físico inicial, banderas rojas a detectar antes de programar.',
    image:
      'https://cdn.magicpatterns.com/uploads/czK9HV7Nb4eAtAnx24tzNr/Bono2_Checklist_Evaluacion.png',
  },
  {
    emoji: '🗒️',
    title: 'Bono 3 — Plantillas de Sesión de 60 Minutos (PDF/Excel)',
    description:
      'Set de plantillas de clase listas para imprimir o usar en el box, organizadas por objetivo (técnica, fuerza, resistencia, simulacro).',
    image:
      'https://cdn.magicpatterns.com/uploads/6YcPCx5DzgBvLfN3qsCceR/Bono3_Plantillas_Sesion.png',
  },
  {
    emoji: '💬',
    title: 'Bono 4 — Guion de Venta para Cerrar Planes Mensuales (PDF)',
    description:
      'Script paso a paso para la primera consulta o clase de prueba, con manejo de objeciones típicas ("es caro", "no sé si voy a poder ir siempre", "ya entreno por mi cuenta").',
    image:
      'https://cdn.magicpatterns.com/uploads/sxNWtiC6UnFtwy235hHQsL/Bono4_Guion_de_Venta.png',
  },
  {
    emoji: '🛡️',
    title:
      'Bono 5 — Rutina de Seguridad y Responsabilidad del Entrenador (PDF)',
    description:
      'Checklist de señales de riesgo a vigilar en clase grupal + protocolo de cuándo y cómo derivar a un profesional médico, para cubrirte legal y profesionalmente.',
    image:
      'https://cdn.magicpatterns.com/uploads/6qNeVQd9SRGR1LSwNQQEYa/Bono5_Rutina_de_Seguridad.png',
  },
]

export const PROBLEMS: string[] = [
  'Programás la misma clase para todos y terminás sobrecargando a los principiantes mientras aburrís a los avanzados.',
  'Sentís que improvisás cada semana y no tenés una estructura clara que puedas repetir sin perder variedad.',
  'Se te van alumnos en temporada baja y no sabés cómo retenerlos cuando termina el calendario de competencias.',
  'Ves compensaciones y fatiga peligrosa en clase, pero no sabés cuándo intervenir o cuándo derivar a un médico.',
  'Trabajás muchísimas horas pero tu negocio no crece: no sabés cómo cerrar planes mensuales ni escalar tu oferta.',
]

export interface Review {
  name: string
  city: string
  text: string
}

export const REVIEWS: Review[] = [
  {
    name: 'Javier M.',
    city: 'Madrid',
    text: 'Llevaba dos años dando clases de HYROX improvisando cada semana. Con esto ya tengo una estructura que repito sin que se note. Mis alumnos progresan y yo trabajo menos horas.',
  },
  {
    name: 'Laura S.',
    city: 'Valencia',
    text: 'El módulo de niveles mixtos me cambió la vida. Antes no sabía cómo dar una sola clase a gente tan distinta. Ahora todos entrenan seguros y contentos.',
  },
  {
    name: 'Carlos R.',
    city: 'Sevilla',
    text: 'Los scripts de venta valen el precio solos. He cerrado 6 planes mensuales nuevos en tres semanas usando el guion de la clase de prueba. Brutal.',
  },
  {
    name: 'Nerea G.',
    city: 'Bilbao',
    text: 'El planificador multi-cliente es oro puro. Gestiono 18 alumnos con distintas competencias sin volverme loca. Ojalá lo hubiera tenido antes.',
  },
]

export interface ShortTestimonial {
  name: string
  age: number
  city: string
  text: string
}

export const SHORT_TESTIMONIALS: ShortTestimonial[] = [
  {
    name: 'Rubén Álvarez',
    age: 34,
    city: 'Zaragoza',
    text: 'Como coach me daba miedo lo legal de las lesiones. La rutina de seguridad me dio la tranquilidad que necesitaba en cada clase.',
  },
  {
    name: 'Marta Iglesias',
    age: 29,
    city: 'Málaga',
    text: 'Pasé de perder alumnos en verano a retenerlos todo el año. La parte de temporada baja es justo lo que me faltaba.',
  },
  {
    name: 'David Torres',
    age: 41,
    city: 'Barcelona',
    text: 'Tengo un box pequeño con material limitado y aun así puedo dar clases de nivel. La gestión de tiempo y espacio es genial.',
  },
  {
    name: 'Sergio Núñez',
    age: 37,
    city: 'A Coruña',
    text: 'Lo compré un martes por la noche y el miércoles ya estaba aplicando las plantillas de sesión. Entrega inmediata de verdad.',
  },
]

export interface Objection {
  q: string
  a: string
}

export const OBJECTIONS: Objection[] = [
  {
    q: '"No tengo tiempo para leer 7 módulos completos"',
    a: 'No hace falta leerlo todo de golpe. Está organizado por módulos y puntos concretos para que vayas directo a lo que necesitas hoy: si mañana tenés una clase con niveles mixtos, vas al Módulo 3 y listo. Además, los bonos (Excel y plantillas) son de aplicación inmediata.',
  },
  {
    q: '"Ya llevo años entrenando, ¿me va a aportar algo?"',
    a: 'Si ya entrenás grupos, este sistema te va a ordenar lo que ya hacés y te va a dar la parte de negocio, venta y retención que casi ningún coach domina. La diferencia entre un buen entrenador y un negocio rentable está justo ahí.',
  },
  {
    q: '"¿Y si no es para mi tipo de gimnasio/box?"',
    a: 'El material está pensado para clases grupales, 1 a 1 e híbrido, con equipamiento limitado o completo. Las plantillas y variaciones se adaptan a tu contexto, no al revés.',
  },
  {
    q: '"27 EUROS me parece una inversión importante"',
    a: 'Con cerrar un solo plan mensual nuevo usando los scripts de venta ya recuperás la inversión varias veces. Y hoy además te llevás los 5 bonos gratis. El precio normal es 78 EUROS.',
  },
]

// For the purchase popup
export const POPUP_NAMES = [
  'Javier',
  'Laura',
  'Carlos',
  'Nerea',
  'Rubén',
  'Marta',
  'David',
  'Sergio',
  'Ana',
  'Pablo',
  'Cristina',
  'Alejandro',
  'Lucía',
  'Miguel',
  'Sara',
  'Iker',
]

export const POPUP_CITIES = [
  'Madrid',
  'Barcelona',
  'Valencia',
  'Sevilla',
  'Bilbao',
  'Zaragoza',
  'Málaga',
  'Murcia',
  'Palma',
  'A Coruña',
  'Granada',
  'Vigo',
  'Gijón',
  'Vitoria',
  'Alicante',
]
